import React from "react";
import type { DataType } from "../types";
import { DateRange, TimeGranularity, DATA_TYPE_OPTIONS } from "../DownloadData";
import { DropdownMultiSelectNoSelectAll } from "./DropdownMultiSelectNoSelectAll";

interface Props {
  dateRange: DateRange;
  setDateRange: (d: DateRange) => void;
  dataType: DataType;
  setDataType: (v: DataType) => void;
  timeGranularity: TimeGranularity;
  setTimeGranularity: (v: TimeGranularity) => void;
}

const TIME_GRANULARITIES: { value: TimeGranularity; label: string }[] = [
  { value: "time_slot", label: "Time Slot (15 min)" },
  { value: "hourly", label: "Hourly" },
  { value: "daily", label: "Daily" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
  { value: "summary", label: "Summary" },
];

export function DataContextSection({
  dateRange,
  setDateRange,
  dataType,
  setDataType,
  timeGranularity,
  setTimeGranularity,
}: Props) {
  return (
    <div className="dd-section-card">
      <div className="dd-section-header">
        <h2 className="dd-section-title">1. Data Context</h2>
      </div>

      <div className="dd-fields-row">
        {/* Date Range */}
        <div className="dd-field-group">
          <span className="dd-field-label">Date Range</span>
          <div className="dd-date-range-wrapper">
            <input
              type="date"
              className="dd-date-input"
              value={dateRange.startDate}
              onChange={(e) =>
                setDateRange({ ...dateRange, startDate: e.target.value })
              }
            />
            <span className="dd-date-separator">to</span>
            <input
              type="date"
              className="dd-date-input"
              value={dateRange.endDate}
              onChange={(e) =>
                setDateRange({ ...dateRange, endDate: e.target.value })
              }
            />
          </div>
        </div>

        {/* Data Type */}
        <div className="dd-field-group">
          <span className="dd-field-label">Data Type</span>
          <DropdownMultiSelectNoSelectAll
            options={DATA_TYPE_OPTIONS}
            value={[dataType]}
            onChange={(selected) => {
              const next = selected[0];
              if (next) {
                setDataType(next as DataType);
              }
            }}
            placeholder="Select Data Type"
            singleSelect
          />
        </div>

        {/* Time Granularity */}
        <div className="dd-field-group">
          <span className="dd-field-label">Time Granularity</span>
          <div
            className="dd-toggle-group"
            role="group"
            aria-label="Time Granularity"
          >
            {TIME_GRANULARITIES.map((g) => (
              <button
                key={g.value}
                type="button"
                className={`dd-toggle-btn ${
                  timeGranularity === g.value ? "dd-toggle-btn--active" : ""
                }`}
                onClick={() => setTimeGranularity(g.value)}
              >
                {g.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
